import { $f } from "@shared/hooks/shared/formatter";
import React, { forwardRef } from "react";

export const Jackpot = ({ slot, currency, index }, ref) => {
  return (
    <div ref={ref} className="jackpot" data-slot={index}>
      <div className="jackpot__image" role="presentation">
        <div
          className="jackpot__desaturated-image"
          style={{ height: slot.isCommunity ? "" : 0 }}
        />
      </div>

      <div className="jackpot__value">
        <span className="jackpot__currency">{currency}</span>
        <span style={{ marginLeft: "12px" }} className="jackpot__value-amount">
          {$f.formatMoney($f.toMoney(slot.value))}
        </span>
      </div>
    </div>
  );
};

export default forwardRef(Jackpot);
